exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".login[data-v-cae36e26]{margin-top:40px}input[data-v-cae36e26]{margin:10px 0;width:20%;padding:15px}button[data-v-cae36e26]{margin-top:20px;width:10%;cursor:pointer}p[data-v-cae36e26]{margin-top:40px;font-size:13px}p a[data-v-cae36e26]{text-decoration:underline;cursor:pointer}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-cae36e26","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/admin/SignUp.vue
// module id = 92
// module chunks = 0